<template>
    <input
        ref="ref_input"
        :class="cls"
        :placeholder="placeholder"
        :type="type"
        v-model="val"
        @input="input($event)"
        @blur="blur"
        @focus="focus"
        @keypress.enter="enter"
        :maxlength="maxlength"
    />
</template>

<script>
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
import { formatValue, setCaret } from '../common/format';
export default {
    emits: ['update:value', 'change', 'blur', 'focus', 'enter'],
    props: ['cls', 'value', 'mask', 'placeholder', 'type', 'maxlength'],
    data: function() {
        return {
            val: ''
        };
    },
    computed: {
        unformatValue() {
            return this.val.replace(/[^\d.]/g, '');
        },
        ...mapState(usePageStore, {
            currencySymbol: store => store.currency?.symbol,
        }),
    },
    methods: {
        format(value, doInput = false) {
            let result = formatValue(this.$refs.ref_input, {
                oldValue: this.unformatValue,
                value: value,
                mask: this.mask,
                currencySymbol: this.currencySymbol
            });
            if (!result) {
                return value;
            }
            if (doInput) {
                this.$nextTick(() => setCaret(this.$refs.ref_input, result.caret));
            }
            return result.value;
        },
        input($event) {
            this.val = this.format($event.target.value, true);
        },
        enter() {
            this.$emit('update:value', this.unformatValue);
            this.dispatch('enter', this.unformatValue);
        },
        change() {
            this.$emit('update:value', this.unformatValue);
            this.dispatch('change');
        },
        blur() {
            if (this.val != this._startEditValue) {
                this.change();
            }
            this.dispatch('blur');
        },
        focus() {
            this._startEditValue = this.val;
            this.dispatch('focus')
        },
        dispatch(type, param) {
            this.$emit(type, param);
        },
        setFocus() {
            this.$refs.ref_input.focus();
        }
    },
    watch: {
        value() {
            this.val = this.format(this.value);
        }
    },
    mounted() {
        this.val = this.format(this.value);
    }
};
</script>
